import Vue from 'vue'
import Router from 'vue-router'
import TopupView from './views/TopupView'
import TopupBack from './views/TopupBack'
import { ROUTING } from './const/routing.const'
import multiguard from 'vue-router-multiguard'
import { EmailQueryGuard, HashQueryGuard } from '@/common/guards/query.guard'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: ROUTING.main,
      name: 'home',
      component: TopupView
    },
    {
      path: ROUTING.back,
      name: 'back',
      component: TopupBack
    },
    {
      path: ROUTING.unregister,
      name: 'Unregister',
      component: () => import ('./views/Unregister'),
      beforeEnter: multiguard([EmailQueryGuard, HashQueryGuard])
    },
    {
      path: '*',
      redirect: ROUTING.main
    }
  ]
})
